import { HttpClient, HttpParams } from '@angular/common/http';
import { GlobalFilterOptions } from '@ot/shared/model';
import { forkJoin, of } from 'rxjs';
import { map, switchAll } from 'rxjs/operators';
import { Environment, EnvironmentConfigService, PlatformServiceName } from '../environment';
import * as i0 from "@angular/core";
import * as i1 from "../../../../model/src/lib/environment.token";
import * as i2 from "../environment/environment-config.service";
import * as i3 from "@angular/common/http";
export class VehicleService {
    constructor(environment, environmentConfigService, http) {
        this.environment = environment;
        this.environmentConfigService = environmentConfigService;
        this.http = http;
        this.pageSize = '25000';
        this.apiUrl =
            this.environmentConfigService.getEnvironmentConfigs().apis.platform.url +
                '/' +
                this.environment.serviceUrlList[PlatformServiceName.VehicleService];
    }
    getVehiclesList(businessAccountId) {
        return this.getVehiclesListPerPage(businessAccountId, '1', this.pageSize);
    }
    getVehiclesListPerPage(businessAccountId, page, pageSize) {
        const parameters = new HttpParams()
            .set('options.page_token', page)
            .set('options.page_size', pageSize);
        const options = { params: parameters };
        return this.http.get(`${this.apiUrl}/businessAccounts/${businessAccountId}/vehicles`, options);
    }
    getAllVehicles(businessAccountId) {
        const observables = [];
        let vehicles = [];
        return this.getVehiclesListPerPage(businessAccountId, '1', this.pageSize).pipe(map((response) => {
            for (let i = 1; i <= Number(response.totalPages); i++) {
                observables.push(this.getVehiclesListPerPage(businessAccountId, i.toString(), this.pageSize));
            }
            if (observables.length !== 0) {
                return forkJoin(observables).pipe(map((listVehiclesResponses) => {
                    for (let j = 0; j < listVehiclesResponses.length; j++) {
                        vehicles = vehicles.concat(listVehiclesResponses[j].vehicles);
                    }
                    return vehicles;
                }));
            }
            else {
                return of([]);
            }
        }), switchAll());
    }
    applyVehicleLabels(businessAccountId, vehicleIds, labels) {
        const url = `${this.apiUrl}/vehicles/labels:apply`;
        const request = this.buildPostLabelsRequest(businessAccountId, vehicleIds, labels);
        return this.http
            .post(url, request)
            .pipe(map(this.mapPostLabelsResponse));
    }
    removeVehicleLabels(businessAccountId, vehicleIds, labels) {
        const url = `${this.apiUrl}/vehicles/labels:remove`;
        const request = this.buildPostLabelsRequest(businessAccountId, vehicleIds, labels);
        return this.http
            .post(url, request)
            .pipe(map(this.mapPostLabelsResponse));
    }
    buildGeneralFilter(businessAccountId) {
        const value = businessAccountId;
        return {
            businessAccountIds: [{ value }]
        };
    }
    buildPostLabelsRequest(businessAccountId, vehicleIds, labels) {
        const globalFilter = this.buildGeneralFilter(businessAccountId);
        return {
            generalFilter: globalFilter,
            vehicleFilter: {
                global: globalFilter,
                vehicleIds: vehicleIds.map(id => ({ value: id }))
            },
            labels
        };
    }
    mapPostLabelsResponse(response) {
        return response.updatedVehicles.map(vehicle => ({
            id: vehicle.id.value,
            customId: vehicle.customId,
            labels: vehicle.labels
        }));
    }
}
VehicleService.ngInjectableDef = i0.defineInjectable({ factory: function VehicleService_Factory() { return new VehicleService(i0.inject(i1.ENVIRONMENT), i0.inject(i2.EnvironmentConfigService), i0.inject(i3.HttpClient)); }, token: VehicleService, providedIn: "root" });
